export default [
  {
    title: 'Category',
    hidden: false
  },
  {
    title: 'Debug',
    hidden: true
  },
  {
    title: 'Hidden',
    key: 'hidden',
    hidden: true
  },
  {
    title: 'Instance ID',
    key: 'InstanceId',
    hidden: false
  },
  {
    title: 'OS Version',
    key: 'osVersionOutput',
    hidden: false
  },
  {
    title: 'Tags - Name',
    key: 'tags-Name',
    find: ['Tags', 'Key', 'Name'],
    hidden: false
  },
  {
    title: 'Image ID',
    key: 'ImageId',
    hidden: false
  },
  {
    title: 'Region',
    key: 'region',
    hidden: false
  },
  {
    title: 'Account ID',
    key: 'accountId',
    hidden: false
  },
  {
    title: 'Account Name',
    key: 'accountName',
    hidden: false
  },
  {
    title: 'AMI Launch Index',
    key: 'AmiLaunchIndex',
    hidden: false
  },
  {
    title: 'Instance Type',
    key: 'InstanceType',
    hidden: false
  },
  {
    title: 'Key Name',
    key: 'KeyName',
    hidden: false
  },
  {
    title: 'Launch Time',
    key: 'LaunchTime',
    hidden: false
  },
  {
    title: 'Monitoring',
    key: 'Monitoring',
    hidden: false
  },
  {
    title: 'Placement',
    key: 'Placement',
    hidden: false
  },
  {
    title: 'Private DNS Name',
    key: 'PrivateDnsName',
    hidden: false
  },
  {
    title: 'Private IP Address',
    key: 'PrivateIpAddress',
    hidden: false
  },
  {
    title: 'Product Codes',
    key: 'ProductCodes',
    hidden: false
  },
  {
    title: 'Public DNS Name',
    key: 'PublicDnsName',
    hidden: false
  },
  {
    title: 'Public IP Address',
    key: 'PublicIpAddress',
    hidden: false
  },
  {
    title: 'State',
    key: 'State',
    hidden: false
  },
  {
    title: 'State Transition Reason',
    key: 'StateTransitionReason',
    hidden: false
  },
  {
    title: 'Subnet ID',
    key: 'SubnetId',
    hidden: false
  },
  {
    title: 'VPC ID',
    key: 'VpcId',
    hidden: false
  },
  {
    title: 'Architecture',
    key: 'Architecture',
    hidden: false
  },
  {
    title: 'Block Device Mappings',
    key: 'BlockDeviceMappings',
    hidden: false
  },
  {
    title: 'Client Token',
    key: 'ClientToken',
    hidden: false
  },
  {
    title: 'EBS Optimized',
    key: 'EbsOptimized',
    hidden: false
  },
  {
    title: 'Hypervisor',
    key: 'Hypervisor',
    hidden: false
  },
  {
    title: 'IAM Instance Profile',
    key: 'IamInstanceProfile',
    hidden: false
  },
  {
    title: 'Elastic GPU Associations',
    key: 'ElasticGpuAssociations',
    hidden: false
  },
  {
    title: 'Network Interfaces',
    key: 'NetworkInterfaces',
    hidden: false
  },
  {
    title: 'Root Device Name',
    key: 'RootDeviceName',
    hidden: false
  },
  {
    title: 'Root Device Type',
    key: 'RootDeviceType',
    hidden: false
  },
  {
    title: 'Security Groups',
    key: 'SecurityGroups',
    hidden: false
  },
  {
    title: 'Source Dest Check',
    key: 'SourceDestCheck',
    hidden: false
  },
  {
    title: 'Tags',
    key: 'Tags',
    hidden: true
  },
  {
    title: 'Virtualization Type',
    key: 'VirtualizationType',
    hidden: false
  },
  {
    title: 'CPU Options',
    key: 'CpuOptions',
    hidden: false
  },
  {
    title: 'Platform',
    key: 'Platform',
    hidden: false
  },
  {
    title: 'ENA Support',
    key: 'EnaSupport',
    hidden: false
  },
  {
    title: 'State Reason',
    key: 'StateReason',
    hidden: false
  },
];


// WEBPACK FOOTER //
// ./src/components/content/ec2Explorer/utils/tableHeaders.js